import urlBuilder from "./urlBuilder";
import { PAGE_TYPE } from "../pages/page.types";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

interface ContentByRouteResponse {
    redirectUrl?: string;
    result: PAGE_TYPE;
    statusCode: number;
    statusText?: string;
}

export default async (route: string): Promise<ContentByRouteResponse> => {
    const url = urlBuilder("/api/content/url", { url: route });


  
    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint(),
  

        },
        body: undefined
    });

    if (response.status === 404) {
        return Promise.resolve({
            result: {
                _contentType: "notFoundPage",
                _name: "Page not found",
                _url: "",
                _culture: "en",
            },
            statusCode: 404
        });
    }

    return await response.json();
};